import { motion } from "framer-motion";
import truck from "../../assets/images/truck2.jpeg";

const MovingTruckBackground = () => {
  const isMobile = window.innerWidth < 768;

  return (
    <motion.img
      src={truck}
      alt="Moving Truck"
      initial={{ x: "-20%" }}
      animate={{ x: "110%" }}
      transition={{
        duration: isMobile ? 18 : 10, // slower on mobile
        repeat: Infinity,
        ease: "linear",
      }}
      style={{
        position: "absolute",
        bottom: isMobile ? "4%" : "8%",
        width: isMobile ? "220px" : "320px",
        opacity: 0.18, // unchanged
        pointerEvents: "none",
        willChange: "transform",
      }}
    />
  );
};

export default MovingTruckBackground;
